import React from "react";
import "antd/dist/antd.css";
import { Form, Input, Collapse } from "antd";
import { connect } from "react-redux";
import * as actions from "../../Store/Actions/index";
import { formatNumber, getHelp, getValidateStatus } from "../../Util/util";
import { getItVendorCost, getHourlyWagePlusBen, getItPersonnelCost } from "../Logics/systemCostCalculations";
import { getLabel } from "../../Util/util";
import { oneTimeSoftwareTooltip, softwareAnnualFeeTooltip, otherSystemCosts } from "../../Util/writing";
import { getIcon } from "../../Util/iconUtil";

const lodash = require("lodash");

const { Panel } = Collapse;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 11 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 12 },
  },
};

const inputFormDivStyle = {
  border: "1px solid #ebedf0",
  borderRadius: "2px",
  marginTop: "5px",
  marginLeft: "20px",
  marginRight: "20px",
  marginBottom: "5px",
  backgroundColor: "white",
  padding: "10px",
};

const SystemCosts = (props) => {
  const otherCost = lodash.get(props.systemCostDetails, "other-system-cost");

  const updateSystemCostAttr = (e) => {
    const inputField = e.currentTarget.id;
    const value = e.currentTarget.value;
    props.setSystemCostAttr({ [inputField]: value });
  };

  return (
    <React.Fragment>
      <div style={inputFormDivStyle}>
        <Form {...formItemLayout}>
          <Collapse expandIcon={() => getIcon(props.systemCostDetails, "systemIt")}>
            <Panel
              header={"IT Cost"}
              key={"software-input-fields"}
              extra={formatNumber(getItVendorCost()) + " " + props.currency}
            >
              <Form.Item
                label={getLabel("One Time Software Installation Cost", oneTimeSoftwareTooltip)}
                help={getHelp(props.systemCostDetails["one-time-software-installation-cost"])}
                validateStatus={getValidateStatus(props.systemCostDetails["one-time-software-installation-cost"])}
              >
                <Input
                  addonAfter={props.currency}
                  placeholder=""
                  id="one-time-software-installation-cost"
                  onChange={updateSystemCostAttr}
                  className="numberInput"
                  value={props.systemCostDetails["one-time-software-installation-cost"]}
                />
              </Form.Item>

              <Form.Item
                label={getLabel("Annual Fee", softwareAnnualFeeTooltip)}
                help={getHelp(props.systemCostDetails["annual-fee"])}
                validateStatus={getValidateStatus(props.systemCostDetails["annual-fee"])}
              >
                <Input
                  addonAfter={props.currency}
                  placeholder=""
                  id="annual-fee"
                  onChange={updateSystemCostAttr}
                  className="numberInput"
                  value={props.systemCostDetails["annual-fee"]}
                />
              </Form.Item>

              <Form.Item label="IT Vendor Cost" help="">
                <Input
                  disabled
                  addonAfter={props.currency}
                  placeholder=""
                  id="it-vendor-cost"
                  value={formatNumber(getItVendorCost())}
                />
              </Form.Item>
            </Panel>
          </Collapse>

          <Collapse expandIcon={() => getIcon(props.systemCostDetails, "systemPersonnel")}>
            <Panel
              header={"IT Personnel Cost"}
              key={"it-input-fields"}
              extra={formatNumber(getItPersonnelCost()) + " " + props.currency}
            >
              <Form.Item
                label="Number of IT Personnel"
                help={getHelp(props.systemCostDetails["number-it-personnel"])}
                validateStatus={getValidateStatus(props.systemCostDetails["number-it-personnel"])}
              >
                <Input
                  addonAfter={props.currency}
                  placeholder=""
                  id="number-it-personnel"
                  onChange={updateSystemCostAttr}
                  className="numberInput"
                  value={props.systemCostDetails["number-it-personnel"]}
                />
              </Form.Item>

              <Form.Item
                label="Hourly Wage of IT Personnel"
                help={getHelp(props.systemCostDetails["wage-it-personnel"])}
                validateStatus={getValidateStatus(props.systemCostDetails["wage-it-personnel"])}
              >
                <Input
                  addonAfter={props.currency}
                  placeholder=""
                  id="wage-it-personnel"
                  onChange={updateSystemCostAttr}
                  className="numberInput"
                  value={props.systemCostDetails["wage-it-personnel"]}
                />
              </Form.Item>

              <Form.Item
                label="Hourly Benefits Amount"
                help={getHelp(props.systemCostDetails["hourly-benefit-amount"])}
                validateStatus={getValidateStatus(props.systemCostDetails["hourly-benefit-amount"])}
              >
                <Input
                  addonAfter="Persons"
                  placeholder=""
                  id="hourly-benefit-amount"
                  onChange={updateSystemCostAttr}
                  className="numberInput"
                  value={props.systemCostDetails["hourly-benefit-amount"]}
                />
              </Form.Item>

              <Form.Item label="Hourly Wage Plus Benefits" help="">
                <Input
                  addonAfter={props.currency}
                  placeholder=""
                  id="wage-plus-benefit"
                  disabled
                  value={formatNumber(getHourlyWagePlusBen())}
                />
              </Form.Item>

              <Form.Item
                label="Retraining Hours"
                help={getHelp(props.systemCostDetails["retraining-hours"])}
                validateStatus={getValidateStatus(props.systemCostDetails["retraining-hours"])}
              >
                <Input
                  addonAfter="Hours"
                  placeholder=""
                  id="retraining-hours"
                  onChange={updateSystemCostAttr}
                  className="numberInput"
                  value={props.systemCostDetails["retraining-hours"]}
                />
              </Form.Item>
            </Panel>
          </Collapse>

          <Collapse expandIcon={() => getIcon(props.systemCostDetails, "systemOther")}>
            <Panel
              header={"Other System Costs"}
              key={"other-system-input-fields"}
              extra={formatNumber(otherCost) + " " + props.currency}
              id="otherSystemCostsPanel"
            >
              <Form.Item
                label={getLabel("Other System Costs", otherSystemCosts)}
                help={getHelp(props.systemCostDetails["other-system-cost"])}
                validateStatus={getValidateStatus(props.systemCostDetails["other-system-cost"])}
              >
                <Input
                  addonAfter={props.currency}
                  placeholder=""
                  id="other-system-cost"
                  onChange={updateSystemCostAttr}
                  className="numberInput"
                  value={props.systemCostDetails["other-system-cost"]}
                />
              </Form.Item>
            </Panel>
          </Collapse>
        </Form>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    currency: state.currency.currency,
    systemCostDetails: state.costs.systemCostDetails,
    costAdjustDetails: state.costs.costAdjustDetails, //Makes sure the component updates when a new timeframe is entered.
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSystemCostAttr: (obj) => dispatch(actions.setSystemCostAttr(obj)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SystemCosts);
